import React from 'react';
import { Route } from 'react-router-dom';
import { LoginPage, SignupPage, ForgotPasswordPage, ResetPasswordPage } from '@features/auth';
import { Box, Typography } from '@mui/material';
import { useAuth } from '@features/auth';

// Debug component to display auth state (development only)
export const AuthDebug = () => {
  const { user, isAuthenticated, token, error } = useAuth();

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>Auth Debug</Typography>
      <pre style={{ background: '#f5f5f5', padding: 16, borderRadius: 4, overflowX: 'auto' }}>
        {JSON.stringify({
          isAuthenticated,
          hasToken: !!token,
          tokenFirstChars: token ? token.substring(0, 15) + '...' : 'none',
          hasUser: !!user,
          userData: user,
          error
        }, null, 2)}
      </pre>
    </Box>
  );
};

export const authRoutes = [
  <Route key="login" path="/login" element={<LoginPage />} />,
  <Route key="signup" path="/signup" element={<SignupPage />} />,
  <Route key="forgot-password" path="/forgot-password" element={<ForgotPasswordPage />} />,
  <Route key="reset-password" path="/reset-password" element={<ResetPasswordPage />} />,

  // Debug route - only in development
  ...((process.env as unknown as Record<string, string | undefined>).NODE_ENV === 'development' ? [
    <Route key="auth-debug" path="/auth-debug" element={<AuthDebug />} />
  ] : [])
];

export default authRoutes;